// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customScrollbarContainer--1tQhYt72::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: transparent;\n  }\n  .customScrollbarContainer--1tQhYt72::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: 4px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customScrollbarContainer": "customScrollbarContainer--1tQhYt72"
};
export default ___CSS_LOADER_EXPORT___;
